module.exports = __webpack_public_path__ + "static/media/social_respon_cn3.daa56771.png";